export default __webpack_public_path__ + "static/media/flowerposter.24776d25.jpg";